


































































































































































































































































































































































































































import BaseFormEdit from '../../models/base.form.edit';
import { Component } from 'vue-property-decorator';
import axios from 'axios';
import { Watch } from 'vue-property-decorator';
import { EventBus } from '@/event-bus';
import moment from "moment";
import ChangePasswordPart from "@/pages/users/ChangePasswordPart.vue";

@Component({ components: { 'change-password-part': ChangePasswordPart } })
export default class Edit extends BaseFormEdit {
  isSetPasswordVisible = false;
  form = {
    isDeleted: false,
    login: '',
    isLocked: false,
    isUser: false,
    code: '',
    lockDate: '',
    password: '',
    passwordLength: 6,
    name: '',
    organizationId: '',
    post: '',
    email: '',
    phone: '',
    additionalPhone: '',
    note: '',
    chat: '',
    organizations: [],
    lang: 1,
    isTcGroup: false,
    isLrGroup: false,
    isLabGroup: false,
    isCcGroup: false,
    isAcGroup: false,
    tcOrganizations: [],
    acOrganizations: [],
    ccOrganizations: [],
    labOrganizations: [],
    lrOrganizations: [],
    selectedTcOrganizations: [],
    selectedAcOrganizations: [],
    selectedCcOrganizations: [],
    selectedLabOrganizations: [],
    selectedLrOrganizations: [],
    confirmPassword: '',
    roles: [],
    histories: [],
  } as any;

  showPassword: any = 'false';

  selectedOrganization: any = null;
  organizationName: any = null;

  created() {
    this.parentValidator.extend('isLoginUnique', this.isLoginUnique);
  }

  get title() {
    return this.form.isNew ? this.$t('Сотрудник') as string : this.$t('Сотрудник') + ` ${this.form.code}, ${this.form.name}`;
  }

  get lockDate() {
    return (this.form.lockDate ? moment(this.form.lockDate) : moment()).format("DD.MM.YYYY HH:mm");
  }

  get canUnlock() {
      return (this.$auth.user().functions.find((t: any) => t.routeName === 'Unlock') != null);
  }

  get isShowPassword() {
    return this.showPassword === 'true' ? true : false;
  }

  isLoginUnique = {
    validate(value: any, args: any) {
      return axios
        .get('/Users/ValidateLogin?login=' + value + '&id=' + args[0])
        .then((response) => {
          return response.data;
        })
        .catch(() => {});
    },
  };
  
  protected onFetchDataFinish() {
    if (this.form.isNew) {
      this.form.lang = 1;
    }
  }

  async organization() {
    EventBus.$emit('showThrobber');
    axios
      .get('/Organizations/' + this.form.organizationId)
      .then((response) => {
        EventBus.$emit('hideThrobber');
        this.selectedOrganization = response.data;
        this.organizationName = this.selectedOrganization.name;
      })
      .catch(() => {
        EventBus.$emit('hideThrobber');
      });
  }

  async beforeSubmit(goBack: boolean) {
    axios.get('/Users/ValidateEmail?email=' + this.form.email + '&id=' + this.form.id).then((response) => {
        if (this.form.email && response.data.length > 0) {
          const div = document.createElement("div");
          div.innerHTML = response.data.join(', ');
          var buttons = {
            ok: {
              className: "btn-primary",
              text: this.$t('Закрыть'),
              value: "ok"
            }
        }
        if(this.$auth.user().functions.find((t: any) => t.routeName === 'CreateUserWithNonUniqueEmail') != null) {
            //@ts-ignore
            buttons.continue = { className: "btn-secondary", text: this.$t('Продолжить') };
          }
          //@ts-ignore
          this.$swal({
            title: this.$t('E-Mail уже используется'),
            content: div,
            icon: "error",
            buttons: buttons
          }).then((value: any) => {
            switch (value) {
              case "continue":
                    this.submit('/Users', goBack);
                break;
            }
          });
        } else {
        this.submit('/Users', goBack);
        }
    })
  }

  async save(goBack: boolean) {
    if (this.form.isNew) {
      if (await this.$validator.validateAll()) {
        if(this.form.isUser)
        {
          this.setPassword();
        }
        else
        {
          this.beforeSubmit(goBack);    
        }
      }
    } else {
      this.beforeSubmit(goBack);
    }
  }

  async setPassword() {    
    this.form.password = '';
    this.form.confirmPassword = '';
    this.$root.$emit('bv::show::modal', 'set-password-modal');
  }

  async changePassword() {
    if (await this.$validator.validateAll()) {
      this.$root.$emit('bv::hide::modal', 'set-password-modal');
      this.beforeSubmit(true);
      }
    }

  cancelChangePassword() {
    this.$root.$emit('bv::hide::modal', 'set-password-modal');
    this.form.password = '';
    this.form.confirmPassword = '';
  }

  @Watch('form.organizationId')
  onOrganizationIdChanged(val: any, oldVal: any) {
    this.organization();
  }

  @Watch('showPassword')
  onShowPassword(val: any, oldVal: any) {
    this.form.confirmPassword = '';
  }

  @Watch('isDataLoaded')
  onIsDataLoaded(val: any, oldVal: any) {
    if (val) {
      this.form.organizationId = this.impersonateOrganizationId || this.form.organizationId;
    }
  }

  @Watch('form.isTcGroup')
  onIsTcGroup(val: any, oldVal: any) {
    if (val) {
      this.form.selectedTcOrganizations = [];
    }
  }

  @Watch('form.isLabGroup')
  onIsLabGroup(val: any, oldVal: any) {
    if (val) {
      this.form.selectedLabOrganizations = [];
    }
  }

  @Watch('form.isCcGroup')
  onIsCcGroup(val: any, oldVal: any) {
    if (val) {
      this.form.selectedCcOrganizations = [];
    }
  }

  @Watch('form.isAcGroup')
  onIsAcGroup(val: any, oldVal: any) {
    if (val) {
      this.form.selectedAcOrganizations = [];
    }
  }

  @Watch('form.isLrGroup')
  onIsLrGroup(val: any, oldVal: any) {
    if (val) {
      this.form.selectedLrOrganizations = [];
    }
  }

  @Watch('form.selectedLabOrganizations')
  onSelectedLabOrganizations(val: any, oldVal: any) {
    if (val && val.length > 0) {
      this.form.isLabGroup = false;
    }
  }

  @Watch('form.selectedCcOrganizations')
  onSelectedCcOrganizations(val: any, oldVal: any) {
    if (val && val.length > 0) {
      this.form.isCcGroup = false;
    }
  }

  @Watch('form.selectedAcOrganizations')
  onSelectedAcOrganizations(val: any, oldVal: any) {
    if (val && val.length > 0) {
      this.form.isAcGroup = false;
    }
  }

  @Watch('form.selectedTcOrganizations')
  onSelectedTcOrganizations(val: any, oldVal: any) {
    if (val && val.length > 0) {
      this.form.isTcGroup = false;
    }
  }

  @Watch('form.selectedLrOrganizations')
  onSelectedLrOrganizations(val: any, oldVal: any) {
    if (val && val.length > 0) {
      this.form.isLrGroup = false;
    }
  }

  groupRoles(group: number) {
    return this.form.roles.filter((t: any) => t.group == group);
  }

  checkAllRoles(value: any, group: any) {
    if (value && this.form.roles) {
      for (let role of this.form.roles) {
        role.isChecked = role.group == group ? true : role.isChecked;
      }
    } else {
      if (this.isAllRolesChecked(group)) {
        for (let role of this.form.roles) {
          role.isChecked = role.group == group ? false : role.isChecked;
        }
      }
    }
  }

  isAllRolesChecked(group: any) {
    let result = true;

    if (this.form.roles) {
      for (let role of this.form.roles) {
        if (role.group == group) {
          result = result && role.isChecked;
        }
      }
    } else {
      result = false;
    }

    return result;
  }

  get isAllChecked() {
    return this.isAllRolesChecked(
      this.selectedOrganization && this.selectedOrganization.group
    );
  }

  set isAllChecked(value) {
    this.checkAllRoles(
      value,
      this.selectedOrganization && this.selectedOrganization.group
    );
  }

  get isTcAllChecked() {
    return this.isAllRolesChecked(2);
  }

  set isTcAllChecked(value) {
    this.checkAllRoles(value, 2);
  }

  get isLrAllChecked() {
    return this.isAllRolesChecked(3);
  }

  set isLrAllChecked(value) {
    this.checkAllRoles(value, 3);
  }

  get impersonateOrganizationId() {
    return this.$router.currentRoute.params.organizationId;
  }
}
